import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const PitchMatcher = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default PitchMatcher